import type * as React from 'react'
import { cn } from '../../lib/utils.ts'

/**
 * Lišta zamčeného seznamu používá variant "default", ne destructive:
 * zamčeno není chyba, jen „tohle nesmíš ty“.
 */
export function Alert({
  className,
  variant = 'default',
  ...p
}: React.ComponentProps<'div'> & { variant?: 'default' | 'destructive' | 'warning' }) {
  const variants = {
    default: 'border-[var(--border)] bg-[var(--muted)] text-[var(--foreground)]',
    warning: 'border-[var(--rule-excess-border)] bg-[var(--rule-excess-surface)] text-[var(--rule-excess)]',
    destructive: 'border-[var(--destructive)]/40 bg-[var(--destructive)]/10 text-[var(--destructive)]',
  }
  return (
    <div
      role={variant === 'destructive' ? 'alert' : 'status'}
      className={cn(
        // Text si drží rozumnou minimální šířku, aby ho ovládání vedle nesmáčklo
        // na pár znaků na řádek — radši se zalomí pod něj.
        'flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[var(--radius-lg)] border px-[var(--space-4)] py-3 text-[length:var(--text-sm)]',
        '[&>p]:min-w-[15rem] [&>p]:flex-1',
        variants[variant],
        className,
      )}
      {...p}
    />
  )
}
